import { DateTime } from 'luxon';
import i18n from 'helpers/i18n';
import messages from './messages';
import Routes from 'helpers/routes';
import { TestStatus } from './Styled';
import { Button, Icon } from 'semantic-ui-react';
import { parseToDateTime } from 'helpers/date/localTimezone';

interface DisplayButtonOrStatusProps {
  /** Status of the attempt: ['passed', 'failed', 'available', 'not_started' (Core), 'in_progress'] */
  status:
    | 'passed'
    | 'failed'
    | 'available'
    | 'not_started'
    | 'in_progress'
    | 'expired';

  /** Boolean expiration of the test */
  expired: boolean;

  /** Test Attempt Id of the test */
  currentAttemptId: Number;

  /** Normally 1st, 2nd, 3rd but it could be up to 5th */
  attemptNumber: string;

  /** Title of the reliability test, used to build an accessible name */
  testName: string;
}

function DisplayButtonOrStatus({
  status,
  expired,
  currentAttemptId,
  attemptNumber,
  testName
}: DisplayButtonOrStatusProps) {
  if (status === 'passed') {
    return (
      <TestStatus passed>
        <Icon color="green" name="check circle" />
        {i18n.ft(messages.passed)}
      </TestStatus>
    );
  }

  if (status === 'failed') {
    return (
      <TestStatus failed>
        <Icon color="red" name="exclamation circle" />
        {i18n.ft(messages.failed)}
      </TestStatus>
    );
  }

  if (expired) {
    return (
      <TestStatus>
        <Icon name="time" />
        {i18n.ft(messages.expired)}
      </TestStatus>
    );
  }

  const handleClick = () => {
    window.location.href = Routes.getPath('test-attempts', {
      id: currentAttemptId
    });
  };

  return (
    <Button
      fluid
      color="blue"
      className="rounded"
      onClick={handleClick}
      aria-label={i18n.ft(messages.goToAttemptAriaLabel, {
        number: attemptNumber,
        name: testName
      })}
    >
      {i18n.ft(messages.goToAttempt, {
        number: attemptNumber
      })}
    </Button>
  );
}

export default DisplayButtonOrStatus;
